var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36.392429px",
    height: "36.392429px",
    viewBox: "0 0 36.392429 36.392429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Cat\\xE9gories---Ajouter",
    transform: "translate(-1205.803785, -212.803785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1224.000000, 231.000000) rotate(-315.000000) translate(-1224.000000, -231.000000) translate(1204.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8.33333333,
    x2: 20,
    y2: 31.6666667,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.33333333,
    y1: 20,
    x2: 31.6666667,
    y2: 20,
    id: "Path",
    stroke: "#030303",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseDark);
export default __webpack_public_path__ + "static/media/icon_close_dark.47de0b86fe80fb2431e2af273fd977e4.svg";
export { ForwardRef as ReactComponent };